import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import get from 'lodash/get'
import { Spinner, ErrorView } from 'Blocks'
import Component from './component'
import { GET_CONTENTS, getInstalooksQueryVariables } from 'Queries'
import config from 'Config'
// TODO to be moved in blocks
const RelatedInstalooksList = props => {
  const queryString = props.location.search
  const variables = getInstalooksQueryVariables(
    queryString,
    config.instalooks.instalook.limit,
    'insta'
  )
  const { loading, error, data } = useQuery(GET_CONTENTS, { variables })

  if (loading) return <Spinner className="spinner" />
  if (error) return <ErrorView message={error.message} error={error} />

  const relatedContent = get(data, 'contents.contents', [])
    .filter(trend => trend.uuid !== props.params.uuid)
    .slice(0, 4)

  if (relatedContent.length) {
    return <Component instalooks={relatedContent} />
  } else {
    return null
  }
}

RelatedInstalooksList.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.any
  }),
  params: PropTypes.shape({
    uuid: PropTypes.any
  })
}

export default RelatedInstalooksList
